/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF API v2.0
 * TAF API with OpenAPI, Swashbuckle, and API versioning.
 * OpenAPI spec version: 2.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CreateSessionResponse,
  IBaseIdentityModel,
  PostApiV2SessionLoginMethodParams
} from '../../models'
import { customInstance } from '../../../../utils/mutator/custom-instance';
import type { ErrorType } from '../../../../utils/mutator/custom-instance';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getApiV2SessionSessionIdValidate = (
    sessionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IBaseIdentityModel>(
      {url: `/proxy/api/v2/session/${sessionId}/validate`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV2SessionSessionIdValidateQueryKey = (sessionId: string,) => {
    return [`/proxy/api/v2/session/${sessionId}/validate`] as const;
    }

    
export const getGetApiV2SessionSessionIdValidateQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2SessionSessionIdValidateQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>> = ({ signal }) => getApiV2SessionSessionIdValidate(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2SessionSessionIdValidateQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>>
export type GetApiV2SessionSessionIdValidateQueryError = ErrorType<unknown>



export function useGetApiV2SessionSessionIdValidate<TData = Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2SessionSessionIdValidateQueryOptions(sessionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV2SessionSessionIdValidateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError = ErrorType<unknown>>(sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV2SessionSessionIdValidateQueryKey(sessionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>> = ({ signal }) => getApiV2SessionSessionIdValidate(sessionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV2SessionSessionIdValidateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>>
export type GetApiV2SessionSessionIdValidateSuspenseQueryError = ErrorType<unknown>



export function useGetApiV2SessionSessionIdValidateSuspense<TData = Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError = ErrorType<unknown>>(
 sessionId: string, options?: { query?:UseSuspenseQueryOptions<Awaited<ReturnType<typeof getApiV2SessionSessionIdValidate>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV2SessionSessionIdValidateSuspenseQueryOptions(sessionId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiV2SessionLoginMethod = (
    loginMethod: string,
    params?: PostApiV2SessionLoginMethodParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CreateSessionResponse>(
      {url: `/proxy/api/v2/session/${loginMethod}`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApiV2SessionLoginMethodMutationOptions = <TData = Awaited<ReturnType<typeof postApiV2SessionLoginMethod>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{loginMethod: string;params?: PostApiV2SessionLoginMethodParams}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {
const mutationKey = ['postApiV2SessionLoginMethod'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV2SessionLoginMethod>>, {loginMethod: string;params?: PostApiV2SessionLoginMethodParams}> = (props) => {
          const {loginMethod,params} = props ?? {};

          return  postApiV2SessionLoginMethod(loginMethod,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError,{loginMethod: string;params?: PostApiV2SessionLoginMethodParams}, TContext>}

    export type PostApiV2SessionLoginMethodMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV2SessionLoginMethod>>>
    
    export type PostApiV2SessionLoginMethodMutationError = ErrorType<unknown>

    export const usePostApiV2SessionLoginMethod = <TData = Awaited<ReturnType<typeof postApiV2SessionLoginMethod>>, TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<TData, TError,{loginMethod: string;params?: PostApiV2SessionLoginMethodParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        TData,
        TError,
        {loginMethod: string;params?: PostApiV2SessionLoginMethodParams},
        TContext
      > => {

      const mutationOptions = getPostApiV2SessionLoginMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    